import styled, { css } from 'styled-components';
import { Media } from '@/js/libs/ui/src/theme/Media';
import { SUBSECTION_DATA_ATTR } from '../../constants';
export const SubSectionWrapper = styled.div.attrs({
    [SUBSECTION_DATA_ATTR]: true,
}) `
  display: flex;
  flex-direction: column;

  ${({ height }) => height &&
    css `
      height: ${height};
    `}
`;
export const TitleWrapper = styled.div `
  margin: 0;
  padding: 19px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ onClick }) => !!onClick && 'pointer'};

  & span {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  @media ${Media.xsMax} {
    padding: 16px 12px;
  }
`;
export const Title = styled.span `
  ${({ theme }) => theme.typography.titleSub};
  padding: 5px 0px;
`;
export const SubTitle = styled.div `
  padding: 4px 24px;

  @media ${Media.xsMax} {
    padding: 4px 16px;
  }
`;
export const ActionsWrapper = styled.div `
  display: flex;
  gap: 8px;
`;
export const CollapsibleWrapper = styled.div `
  position: relative;
  flex: ${({ hasFixedHeight }) => (hasFixedHeight ? '1' : '0 1 auto')};
  min-height: 0;
  overflow: auto;
`;
export const ContentWrapper = styled.div `
  padding: ${({ noPadding, withoutTitle }) => (noPadding ? 0 : withoutTitle ? '24px' : '0 24px 24px')};

  @media ${Media.xsMax} {
    padding: ${({ noPadding, withoutTitle }) => (noPadding ? 0 : withoutTitle ? '16px 12px' : '0 12px 16px')};
  }

  ${({ horizontal }) => horizontal &&
    css `
      display: flex;
      flex-direction: row;

      & > * {
        flex: 1 1 0;
        min-width: 0;
      }

      & > * + * {
        border-left: 1px solid ${({ theme }) => theme.colors.grey10_1};
      }
    `}

  ${({ customStyles }) => customStyles}
`;
